import TypeString from "../valueObject/TypeString";
import LenderPortfolioGateway from "./LenderPortfolioGateway";

export default class LenderPortfolioService {
    static searchByKeyword(keyword: TypeString) {
        return new LenderPortfolioGateway().search(keyword);
    }
}
